import { jsx as m } from "react/jsx-runtime";
import '../../assets/SimpleText.css';function c({
  variant: r = "normal",
  className: l = "",
  center: n,
  size: o = "normal",
  style: t,
  children: e,
  bold: s
}) {
  const a = `text text--${r} ${l} ${n ? "text--center" : ""} ${s ? "text--bold" : ""}`;
  return o === "small" ? /* @__PURE__ */ m("small", { className: a, style: t, children: e }) : /* @__PURE__ */ m("span", { className: a, style: t, children: e });
}
export {
  c as SimpleText
};
//# sourceMappingURL=SimpleText.js.map
